import { render, staticRenderFns } from "./Lipcheck_success.vue?vue&type=template&id=ff3933c6&scoped=true"
import script from "./Lipcheck_success.vue?vue&type=script&lang=js"
export * from "./Lipcheck_success.vue?vue&type=script&lang=js"
import style0 from "./Lipcheck_success.vue?vue&type=style&index=0&id=ff3933c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff3933c6",
  null
  
)

export default component.exports